import { RoundButton } from '@cian/ui-kit';
import { useDeviceType } from '@cian/ui-kit/responsive';
import { IconToggleHeartOff16, IconToggleHeartOn16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './FavoriteButton.css';
import { ETestId } from '../../constants/testId';

interface ILikeButtonContainerProps {
  isFavorite: boolean;
  darkButton?: boolean;
  onAdd?(): void;
  onRemove?(): void;
}

export const FavoriteButton = ({ isFavorite, onAdd, onRemove }: ILikeButtonContainerProps) => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';
  const onClick = React.useMemo(() => (isFavorite ? onRemove : onAdd), [isFavorite, onAdd, onRemove]);

  const buttonTitle = isFavorite ? 'Удалить из избранного' : 'Добавить в избранное';
  const icon = isFavorite ? (
    <span className={styles['heart-active']}>
      <IconToggleHeartOn16 color="current_color" aria-label="heartActive" display="block" />
    </span>
  ) : (
    <IconToggleHeartOff16 color="white_100" aria-label="heart" display="block" />
  );

  return (
    <div className={styles['button']}>
      <RoundButton
        theme="fill_dark"
        size={isMobile ? 'M' : 'XS'}
        onClick={onClick}
        title={buttonTitle}
        icon={icon}
        data-testid={ETestId.FavoriteButton}
      />
    </div>
  );
};
